import { State } from "./state";
import { storeInit } from "../../../Store";
export const initialState: State.Data = {
  unix: ""
};

export const initial: State.Props = storeInit<State.Data>(initialState);

export default initial;
